import { PaletteMode, Components, Theme } from '@mui/material';
import { themePalette } from '../theme.palette';

export const MuiSliderTheme = (mode: PaletteMode): Components<Theme>['MuiSlider'] => {
  const { tokens } = themePalette(mode);

  return {
    styleOverrides: {
      thumb: {
        color: tokens.textPrimary,
      },
      track: {
        color: tokens.primaryLight,
      },
      rail: {
        color: tokens.backgroundDefault,
      },
    },
  };
};
